export default __webpack_public_path__ + "cfccc6d927fa4cad9e3077c14ab0f713.png";